import { sha256 } from 'js-sha256';

/**
 * Derives a 2-byte shared secret hint from a 32-byte shared secret.
 * 
 * This hint is used to filter messages before attempting full decryption.
 *
 * @param sharedSecret - 32-byte Uint8Array derived from ECDH
 * @returns Uint8Array - 2-byte hint
 */
export function deriveSharedSecretHint(sharedSecret: Uint8Array): Uint8Array {
  if (!(sharedSecret instanceof Uint8Array) || sharedSecret.length !== 32) {
    throw new Error('Expected sharedSecret to be a 32-byte Uint8Array');
  }

  const fullHash = new Uint8Array(sha256.array(sharedSecret));
  return fullHash.slice(0, 2); // first 2 bytes as hint
}